import React, { Component } from 'react';
import { Button, Col, Form, Input, Modal, notification, Row, Select, Spin } from 'antd';
import _ from 'lodash';

import * as programmeController from '../../../../../../../../services/api/programme';
import * as channelController from '../../../../../../../../services/api/channel';
import { leadTypeOptions } from '../../../../../../../../utils/options';
import './AdLinkFormModal.scss';

const FormItem = Form.Item;
const { Option } = Select;

export class AdLinkFormModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            programmes: [],
            isLoading: false
        }
    }

    fetchProgrammes() {
        programmeController.getProgrammes({ isSimple: true })
            .then((res) => res.json())
            .then((json) => this.setState({ programmes: json }))
    }

    fetchAdLink() {
        const { form, channelId, adLinkId } = this.props;

        channelController.getChannelAdLink(channelId, adLinkId)
            .then((res) => res.json())
            .then((json) => form.setFieldsValue({
                code: json.code,
                enquiry_type: json.enquiry_type,
                programme_id: json.programme_id
            }))
    }

    handleSubmit(e) {
        const { form, channelId, adLinkId, onCreateUpdate } = this.props;
        const isCreateNewAdLink = adLinkId === undefined;

        e.preventDefault();

        this.setState({ isLoading: true });

        form.validateFields((err, values) => {
            if (!err) {
                let body = values;

                if (values.enquiry_type === 'Other Enquiry') {
                    body.programme_id = null;
                }

                (isCreateNewAdLink ? channelController.createChannelAdLink(channelId, body) : channelController.updateChannelAdLink(channelId, adLinkId, body))
                .then((res) => res.json())
                    .then((json) => {
                        this.setState({ isLoading: false });
                        onCreateUpdate();
                    })
                    .catch((err) => {
                        notification.error({
                            message: 'Unexpected Error',
                            description: 'Please report this issue to engineer.',
                            duration: 0
                        });
                        this.setState({ isLoading: false });
                    })
            } else {
                this.setState({ isLoading: false });
            }
        });
    }

    componentDidMount() {
        this.fetchProgrammes();
    }

    componentDidUpdate(prevProps, prevState) {
        const { form, visible, adLinkId } = this.props;

        if (visible !== prevProps.visible && visible) {
            form.resetFields();

            if (adLinkId)
                this.fetchAdLink();
        }
    }

    render() {
        const { form, visible, channelId, adLinkId, onCancel } = this.props;
        const { programmes, isLoading } = this.state;

        const { getFieldDecorator } = form;
        const isCreateNewAdLink = adLinkId === undefined;
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 16 },
            },
        };

        const isAboutProgramme = form.getFieldValue('enquiry_type') !== 'Other Enquiry';

        return (
            <Modal
                width="60%"
                style={{ pointerEvents: isLoading ? 'none' : '' }}
                maskClosable={!isLoading}
                wrapClassName="AdLinkFormModal"
                visible={visible}
                footer={null}
                onCancel={onCancel}
            >
                <Spin spinning={isLoading}>
                    <h2>{ isCreateNewAdLink ? 'Create New Ad-link' : 'Edit Ad-link' }</h2>
                    <Form className="AdLinkForm" onSubmit={(e) => this.handleSubmit(e)}>
                        <Row gutter={32}>
                            <Col span={24}>
                                <FormItem {...formItemLayout} label="Channel">
                                    {channelId}
                                </FormItem>
                            </Col>
                        </Row>
                        <Row gutter={32}>
                            <Col span={24}>
                                <FormItem {...formItemLayout} label="Code">
                                    {
                                        getFieldDecorator('code', {
                                            rules: [{
                                                required: true,
                                            }],
                                        })(
                                            <Input placeholder="Code" style={{ width: 200 }} />
                                        )
                                    }
                                </FormItem>
                            </Col>
                        </Row>
                        <Row gutter={32}>
                            <Col span={24}>
                                <FormItem {...formItemLayout} label="Enquiry Type">
                                    {
                                        getFieldDecorator('enquiry_type', {
                                            rules: [{
                                                required: true,
                                            }],
                                        })(
                                            <Select style={{ width: 300 }}>
                                                {_.map(leadTypeOptions, (option) => <Option key={option} value={option}>{option}</Option>)}
                                            </Select>
                                        )
                                    }
                                </FormItem>
                            </Col>
                        </Row>
                        {
                            isAboutProgramme &&
                                <Row gutter={32}>
                                    <Col span={24}>
                                        <FormItem {...formItemLayout} label="Programme">
                                            {
                                                getFieldDecorator('programme_id', {
                                                    rules: [{
                                                        required: isAboutProgramme,
                                                    }],
                                                })(
                                                    <Select style={{ width: 300 }}>
                                                        {_.map(programmes, (programme) => <Option key={programme.id} value={programme.id}>{programme.name}</Option>)}
                                                    </Select>
                                                )
                                            }
                                        </FormItem>
                                    </Col>
                                </Row>
                        }
                        <Row>
                            <FormItem>
                                <Button type="primary" htmlType="submit">{isCreateNewAdLink ? 'Create' : 'Update'}</Button>
                            </FormItem>
                        </Row>
                    </Form>
                </Spin>
            </Modal>
        );
    }
}

const WrappedAdLinkFormModal = Form.create()(AdLinkFormModal);
export default WrappedAdLinkFormModal;


// WEBPACK FOOTER //
// ./src/scenes/DashboardPage/scenes/ChannelManagementPage/scenes/AdLinkManagementPane/components/AdLinkFormModal/AdLinkFormModal.js